(() => {
  if (window.themeImageWarmup) return;

  const selector = 'img[loading="lazy"], img[data-nav-src], img[data-menu-src], img.lazyload, [data-bgset]';
  const excluded = '.shopify-app-block, .shopify-block, [id^="shopify-block-"], .hc-widget, .lmr-dialog, .lmr-reviews, .lmr-filter-results, .fslightbox-container, #rebuy-cart, [data-rebuy-id], [data-image-warmup="off"]';
  const busy = '.cc-product-filter-container--loading, .product-purchase-form .adding, #rebuy-cart[aria-hidden="false"], main [aria-busy="true"]';
  const pending = new Set();
  const started = new WeakSet();
  const mobileMenu = window.matchMedia('(max-width: 1023px)');
  const mobileImages = window.matchMedia('(max-width: 767px)');
  let active = 0;
  let ready = false;
  let timer;
  let refreshTimer;
  let pauseUntil = 0;

  function eligible(element) {
    if (!element.isConnected || element.closest(excluded)) return false;
    if (element.closest('#mobile-menu-panel')) return mobileMenu.matches;
    if (element.closest('#main-desktop-navigation')) return !mobileMenu.matches;
    if (element.closest('#page-menu') && element.hasAttribute('data-menu-src')) {
      return !!document.querySelector('#site-control [data-modal-nav-toggle]')?.getClientRects().length;
    }
    if (element.closest('.image__second') && mobileImages.matches) return false;
    if (element.closest('.theme-gallery')) return true;
    return element.getClientRects().length > 0;
  }

  function finished(element) {
    if (element.hasAttribute('data-nav-src') || element.hasAttribute('data-menu-src')) return false;
    if (element.hasAttribute('data-bgset')) return element.classList.contains('lazyloaded');
    if (element.classList.contains('lazyload')) return false;
    return element.complete && !!(element.currentSrc || element.getAttribute('src'));
  }

  function warm(element) {
    active++;
    started.add(element);
    let settled = false;
    const finish = event => {
      if (event?.type === 'lazyloaded' && event.target !== element) return;
      if (settled) return;
      settled = true;
      for (const type of ['load', 'error', 'lazyloaded']) element.removeEventListener(type, finish, true);
      element.removeEventListener('lazybeforeunveil', prioritize, true);
      active--;
      pump();
    };
    const prioritize = event => {
      if (event.target instanceof HTMLImageElement) {
        event.target.fetchPriority = 'low';
        event.target.decoding = 'async';
      }
    };
    for (const type of ['load', 'error', 'lazyloaded']) element.addEventListener(type, finish, true);
    element.addEventListener('lazybeforeunveil', prioritize, true);

    if (element instanceof HTMLImageElement) {
      element.fetchPriority = 'low';
      element.decoding = 'async';
      const source = element.dataset.navSrc || element.dataset.menuSrc;
      if (source) {
        element.src = source;
        element.removeAttribute('data-nav-src');
        element.removeAttribute('data-menu-src');
      }
      element.loading = 'eager';
    }
    if (element.hasAttribute('data-bgset') || element.classList.contains('lazyload')) {
      if (window.lazySizes?.loader) window.lazySizes.loader.unveil(element);
      else finish();
    } else if (element.complete) {
      queueMicrotask(() => finish());
    }
  }

  function pump() {
    clearTimeout(timer);
    if (!ready || document.hidden || active >= 2) return;
    if (performance.now() < pauseUntil || document.querySelector(busy)) {
      timer = setTimeout(pump, Math.max(250, pauseUntil - performance.now()));
      return;
    }
    for (const element of pending) {
      if (!element.isConnected || started.has(element) || finished(element)) {
        pending.delete(element);
        continue;
      }
      if (!eligible(element) || element.classList.contains('lazyloading')) continue;
      pending.delete(element);
      warm(element);
      if (active >= 2) break;
    }
  }

  function collect() {
    if (!ready) return;
    pending.clear();
    for (const scope of ['main', 'footer, [data-section-type="footer"]', '#mobile-menu-panel', '#main-desktop-navigation', '#site-control', '#page-menu']) {
      for (const root of document.querySelectorAll(scope)) {
        for (const element of root.querySelectorAll(selector)) {
          if (!started.has(element) && !element.closest(excluded)) pending.add(element);
        }
      }
    }
    pump();
  }

  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(collect, 100);
  }

  function pause() {
    pauseUntil = performance.now() + 2000;
    if (ready) {
      clearTimeout(timer);
      timer = setTimeout(pump, 2000);
    }
  }

  function begin() {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      ready = true;
      collect();
    }));
  }

  window.themeImageWarmup = { refresh };
  document.addEventListener('pointerdown', pause, { passive: true, capture: true });
  document.addEventListener('keydown', pause, { capture: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) collect(); });
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('pageshow', refresh);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && !node.closest(excluded) && (node.matches(selector) || node.querySelector(selector))
    ))) refresh();
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'complete') begin();
  else window.addEventListener('load', begin, { once: true });
})();
